<template>
    <div class="download-page">
        <img class="logo-img" src="../assets/ic_logo.png" />
        <span class="title">窝窝投</span>
        <span class="desc">投你所爱</span>
        <span class="btn disable-select" @click="handleDownloadApp"
            >立即下载APP</span
        >
        <div class="wx-tip" v-if="showWXTip">
            <img src="../assets/open.png" />
            <span>请点击菜单选择复制连接至其他浏览器打开</span>
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";

export default {
    name: "Download",
    data() {
        return {
            timer: null,
            timerIOS: null,
            schemeUrl: "com.qianling.bmb://",
            downloadYYBUrl:
                "https://sj.qq.com/myapp/detail.htm?apkName=com.qianling.bmb",
            downloadUrl:
                "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/common/app-prod-release.apk",
            downloadIOSUrl: "itms-apps://apps.apple.com/us/app/id1576996008",
            downloadAndroidUrl: "https://sj.qq.com/appdetail/com.dyw.wowoto",
            showWXTip: false,
        };
    },
    computed: {
        downloadAppUrl() {
            if (this.isAndroid()) {
                return {
                    url: this.downloadAndroidUrl,
                    // url: 'https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/common/app-prod-release.apk',
                    platform: "Android",
                };
            }
            if (this.isIOS()) {
                return {
                    url: this.downloadIOSUrl,
                    platform: "IOS",
                };
            }
            return {
                url: "",
                platform: "",
            };
        },
    },
    mounted() {
        const ua = window.navigator.userAgent.toLowerCase();
        // eslint-disable-next-line
        // if (this.isAndroid) {
        //     if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //         this.showWXTip = true;
        //     } else {
        //         this.showWXTip = false;
        //     }
        // }
        // this.handleDownloadApp();
    },
    methods: {
        handleDownloadApp() {
            if (this.downloadAppUrl.url) {
                window.location = this.downloadAppUrl.url;
            } else {
                this.downloadAppUrl.platform === "IOS" &&
                    Toast({
                        message: "IOS目前暂不支持下载，敬请期待",
                    });
            }
            console.log(this.isAndroid(), this.isIOS());
            // const ua = window.navigator.userAgent.toLowerCase()
            // if (ua.match(/MicroMessenger/i) === 'micromessenger') {
            //     window.location = this.downloadUrl
            // } else {
            //     this.openApp()
            // }
        },

        openApp() {
            this.openLoading();
            window.location = this.schemeUrl;
            this.timer = setTimeout(() => {
                this.closeLoading();
                if (!document.hidden) {
                    console.log("timer ", !document.hidden);
                    window.location.href = this.downloadUrl;
                    setTimeout(() => {
                        window.close();
                    }, 2000);
                }
            }, 4000);
            window.addEventListener("pagehide", () => {
                console.log("pagehide ", document.hidden);
                this.closeTimer();
            });
            window.addEventListener(
                "visibilitychange",
                (event) => {
                    console.log("visibilitychange ", document.hidden);
                    const hidden = event.target.webkitHidden;
                    if (hidden) {
                        this.closeTimer();
                    }
                },
                false
            );
            window.addEventListener(
                "webkitvisibilitychange",
                (event) => {
                    console.log("webkitvisibilitychange ", document.hidden);
                    const hidden = event.target.webkitHidden;
                    if (hidden) {
                        this.closeTimer();
                    }
                },
                false
            );
            if (this.isIOS()) {
                this.openPageVisibleCheck();
            }
        },
        isAndroid() {
            // true代表Android端 false代表ios端
            const u = navigator.userAgent;
            const isAndroid =
                u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // android终端或者uc浏览器
            return isAndroid === true;
        },
        isIOS() {
            // true代表Android端 false代表ios端
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
            return isiOS === true;
        },
        openPageVisibleCheck() {
            this.timerIOS = setInterval(() => {
                console.log("timerIOS ", document.hidden, window.frames.length);
                if (document.hidden) {
                    this.closeTimer();
                }
            }, 500);
        },
        closeTimer() {
            console.log("closeTimer ", document.hidden);
            this.timerIOS && clearInterval(this.timerIOS);
            this.timer && clearTimeout(this.timer);
        },
        openLoading() {
            Toast.loading({
                message: "加载中...",
                duration: 0, // 持续展示 toast
                forbidClick: true,
                loadingType: "spinner",
            });
        },
        closeLoading() {
            Toast.clear();
        },
    },
};
</script>

<style scoped lang="less">
.download-page {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    .logo-img {
        width: 84px;
        height: 84px;
        margin-top: 132px;
        border-radius: 20px;
    }
    .title {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 33px;
        margin-top: 24px;
    }
    .desc {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 25px;
        margin-top: 6px;
    }
    .btn {
        margin-top: 104px;
        width: 327px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(180deg, #17c1ce 0%, #17ce92 100%);
        border-radius: 7px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 22px;
        &:active {
            opacity: 0.8;
        }
    }
    .wx-tip {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        img {
            width: 54px;
        }
        span {
            display: block;
            width: 109px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 20px;
            padding-right: 20px;
        }
    }
}
</style>
